var _path, _circle, _circle2, _circle3, _circle4, _circle5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup151(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 29,
    viewBox: "0 0 88 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.88739 27.4426C1.37529 26.9547 5.55068 23.8036 9.27418 21.0228C11.4699 19.3829 14.5578 19.7261 16.349 21.8002V21.8002C18.7206 24.5462 23.0983 24.107 24.8771 20.9446L30.9955 10.0675C33.3268 5.92299 39.343 6.06965 41.4696 10.3228L44.9585 17.3007C46.8028 20.9894 51.7557 21.7163 54.5822 18.7131L59.4175 13.5756C61.1514 11.7333 63.8631 11.1937 66.1703 12.2319L67.4345 12.8008C69.4886 13.7252 71.8891 13.4061 73.6304 11.9773L87.3097 0.753351",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.847277
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.15781,
    cy: 27.0193,
    r: 1.69455,
    fill: "#776AD3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.7972,
    cy: 23.6294,
    r: 1.69455,
    fill: "#776AD3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.4397,
    cy: 8.37827,
    r: 1.69455,
    fill: "#776AD3"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.9242,
    cy: 13.463,
    r: 1.69455,
    fill: "#776AD3"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.4119,
    cy: 8.37827,
    r: 1.69455,
    fill: "#776AD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup151);
export default __webpack_public_path__ + "static/media/Group 151.e96ba3cd25fab7bb795c9c3ce6458081.svg";
export { ForwardRef as ReactComponent };